module.exports = __webpack_public_path__ + "img/minipro_live.20a6fbf0.jpg";